const done = (fn: () => void) => setTimeout(fn, 0);

export interface CancelablePromiseRejection {
  isCancelled?: boolean;
}

const cancelable = <T>(promise: Promise<T>) => {
  let isCancelled = false;

  const wrapper = new Promise<T>((resolve, reject) =>
    promise
      .then((value) => (isCancelled ? reject({ isCancelled }) : resolve(value)))
      .catch((error) => reject({ isCancelled, status: error.response?.status })),
  );

  return { promise: wrapper, cancel: () => (isCancelled = true) };
};

export { done, cancelable };
